import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import KeyRoundedIcon from '@mui/icons-material/KeyRounded'
import AlternateEmailRoundedIcon from '@mui/icons-material/AlternateEmailRounded'
import VisibilityRoundedIcon from '@mui/icons-material/VisibilityRounded'
import VisibilityOffRoundedIcon from '@mui/icons-material/VisibilityOffRounded'
import store from '../store/store'


export default function Signup() {
    const isMenuOpen = store((state) => state.isMenuOpen)
    const setIsMenuOpen = store((state) => state.setIsMenuOpen)

    const [displayPassword, setDisplayPassword] = useState(false)

    // auto close the menu once the page is loaded
    useEffect(() => {
        isMenuOpen&& setIsMenuOpen(false)
    },[])

    return (
        <main>
            <div id='sign_background'>
                <form id='sign_form'>
                    <div id='sign_form_heading'>
                        <h1>Welcome!</h1>
                        <h4>Please fill your informations to sign up</h4>
                    </div>
                    <div id='sign_form_inputs'>
                        <label id='sign_email'>
                            <div className='input_wrapper'>
                                <input id='sign_input_email' type="email" name="email" placeholder='Email' />
                                <AlternateEmailRoundedIcon id='sign_icon'/>
                            </div>
                        </label>
                        <label id='sign_password'>
                            <div className='input_wrapper'>
                                <input id='sign_input_password' type="password" name="password" placeholder='Password'  />
                                <KeyRoundedIcon id='sign_icon'/>
                            </div>
                        </label>
                        <label id='sign_password'>
                            <div className='input_wrapper'>
                                <input id='sign_input_password_check' type={displayPassword? 'text' : "password"} name="password" placeholder='Password check'  />
                                {displayPassword?
                                    <VisibilityRoundedIcon id='sign_icon_click' onClick={() => setDisplayPassword(!displayPassword)}/>
                                :
                                    <VisibilityOffRoundedIcon id='sign_icon_click' onClick={() => setDisplayPassword(!displayPassword)}/>
                                }
                            </div>
                        </label>
                    </div>
                    <p id='sign_password_check' >Make sure it's at least 15 characters OR at least 8 characters including a number and a lowercase letter.</p>
                    <button id='sign_button' type="submit">Sign Up</button>
                    <p id='sign_signup'>Already have an account? <Link to='/signin' id='sign_account_link'>go sign in</Link></p>
                </form>
            </div>
        </main>
    )
}
